import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';


export default function NavItem({ item }) {
  const t = useTranslations('header.navbar');
  
  return (
      <li className={`${item.dropdown ? "menu-icon" : ""}`}>
        { item.path ? (<Link href={item.path}>{t(item.name)}</Link>) : <span className="linkable">{t(item.name)}</span> }
        {item.dropdown ?? ""}
      </li>
  );
};
